import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=6f05ee16&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=ts&"
export * from "./Settings.vue?vue&type=script&lang=ts&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=6f05ee16&lang=sass&scoped=true&"
import style1 from "./Settings.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05ee16",
  null
  
)

export default component.exports